import { Accordion, AccordionDetails, Typography } from '@mui/material';
import { ExpandMore } from '@mui/icons-material';
import { FormikProps } from 'formik';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import { ArchiveAnnotationsForm } from 'civil-status/view-models/archive-annotations-list';
import FormFiltersArchiveAnnotations from './form';
import { memo } from 'react';

interface FiltersPecProps {
  filters: FormikProps<ArchiveAnnotationsForm>;
  setOpen: (value: boolean) => void;
  open?: boolean;
}

const FiltersArchiveAnnotationsComponent = ({
  filters,
  setOpen,
  open,
}: FiltersPecProps): React.ReactElement => {
  return (
    <Accordion
      expanded={open}
      onChange={() => {
        setOpen(!open);
      }}
    >
      <AccordionSummary
        aria-controls="panel-filters-pec-content"
        id="panel-filters-pec-header"
        classes={{
          root: 'pmi-flex-row-reverse',
        }}
        expandIcon={<ExpandMore />}
      >
        <Typography>Filtri</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <FormFiltersArchiveAnnotations filters={filters} />
      </AccordionDetails>
    </Accordion>
  );
};

FiltersArchiveAnnotationsComponent.displayName = 'Filters Archive Annotations component';

const FiltersArchiveAnnotations = memo(FiltersArchiveAnnotationsComponent);

export default FiltersArchiveAnnotations;
